import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, withTheme } from '@material-ui/core/styles';
import collectLifelineEvents from './collectLifelineEvents';
import Controls from './Controls/Controls';
import Line from './Line/Line';
import Events from './Events/Events';
import config from './config';

const styles = () => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  lifelineWrapper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'auto',
  },
  Lifeline: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    marginTop: '1vh',
    marginLeft: '120px',
    marginBottom: '5vh',
    flexShrink: 1,
    flexGrow: 1,
  },
});

export class Lifeline extends React.Component {
  constructor(props) {
    super(props);
    this.eventsRef = React.createRef();
    this.state = {
      yearWidth: config.YEAR_WIDTH,
    };
  }

  componentDidUpdate(prevProps) {
    const { logbookIsExpanded } = this.props;
    if (logbookIsExpanded !== prevProps.logbookIsExpanded) {
      this.eventsRef.current.setLayerCount(1);
      setTimeout(() => {
        if (this.eventsRef && this.eventsRef.current) this.eventsRef.current.updateLayerCount();
      }, 500);
    }
  }

  render() {
    const {
      elephant, focusedDate, onDateSelected, onElephantSelected, classes,
    } = this.props;

    const { yearWidth } = this.state;

    const lifelineEvents = collectLifelineEvents(elephant);

    const start = lifelineEvents[0].date;
    const end = lifelineEvents[lifelineEvents.length - 1].date;

    const lifelineWidth = end.diff(start, 'days') / 365 * yearWidth + 200;
    const lifelineMinHeight = config.LINE_HEIGHT + config.MAX_EVENT_HEIGHT + 40;

    return (
      <div className={classes.wrapper}>
        <Controls onYearWidthChange={(value) => {
          this.setState({ yearWidth: value });
        }}
        />
        <div className={classes.lifelineWrapper}>
          <div
            className={classes.Lifeline}
            style={{
              width: `${lifelineWidth}px`,
              minHeight: `${lifelineMinHeight}px`,
            }}
          >
            <Events
              yearWidth={yearWidth}
              elephant={elephant}
              events={lifelineEvents}
              ref={this.eventsRef}
              onEventSelected={event => onDateSelected(event.date)}
              onElephantSelected={onElephantSelected}
              start={start}
              focusedDate={focusedDate}
            />
            <Line
              yearWidth={yearWidth}
              events={lifelineEvents}
              onDateSelected={onDateSelected}
              elephant={elephant}
              focusedDate={focusedDate}
            />
          </div>
        </div>
        <div className={classes.padding} />
      </div>
    );
  }
}

Lifeline.propTypes = {
  elephant: PropTypes.shape().isRequired,
  onDateSelected: PropTypes.func,
  onElephantSelected: PropTypes.func,
  focusedDate: PropTypes.shape(),
  logbookIsExpanded: PropTypes.bool,
  classes: PropTypes.shape().isRequired,
};

Lifeline.defaultProps = {
  onDateSelected: () => {},
  onElephantSelected: () => {},
  focusedDate: null,
  logbookIsExpanded: false,
};

export default withTheme()(withStyles(styles)(Lifeline));



// WEBPACK FOOTER //
// ./src/components/lifeline/Lifeline.jsx